<template>
    <div class="file-input" :class="{ 'has-attachment': files.length }">
        <input class="file-input__hidden" type="file" :multiple="multiple" @change="renderInput($event)" :accept="accept"
            ref="hiddenInput">
        <div class="file-input__visible" data-tippy-content="Вы можете сразу выбрать один или несколько файлов">
            <span class="file-input__icon-n-text" @click.prevent="openSearch">
                <svg class="file-input__icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M12.501 5.833L7.085 11.25a1.768 1.768 0 102.5 2.5L15 8.333a3.535 3.535 0 10-5-5L4.585 8.75a5.303 5.303 0 107.5 7.5l5.416-5.417"
                        stroke="currentColor" stroke-width="1.667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span class="file-input__text">
                    <div>{{ filesText }}</div>
                    <div v-if="files.length && multiple">(Всего: {{ files.length }})</div>
                </span>
            </span>
            <span class="file-input__delete-btn" @click="clearInput($event)" title="Очистить">
                <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path stroke="currentColor" stroke-width="1.667" stroke-linecap="round" stroke-linejoin="round"
                        d="M3.332 5.833h13.333M8.332 9.166v5m3.336-5v5m-7.5-8.333l.833 10A1.667 1.667 0 006.668 17.5h6.667A1.666 1.666 0 0015 15.833l.834-10m-8.334 0v-2.5a.833.833 0 01.833-.833h3.334a.833.833 0 01.833.833v2.5" />
                </svg>
            </span>
        </div>
    </div>
</template>
<script>
export default {
    props: [
        'multiple',
        'placeholder',
        'accept'
    ],
    data() {
        return {
            files: [],
            filesText: this.placeholder || 'Прикрепить файл',
        };
    },
    methods: {
        openSearch() {
            this.$refs.hiddenInput.click();
        },
        renderInput() {
            this.files = this.$refs.hiddenInput.files;
            if (this.files.length > 0) {
                this.filesText = '';
                for (let item of this.files) {
                    this.filesText = this.filesText + item.name + ', ';
                }
                this.filesText = this.filesText.substr(0, this.filesText.length - 2);
            } else {
                this.filesText = this.placeholder || 'Прикрепить файл';
            }
        },
        clearInput() {
            let emptyInput = document.createElement('input');
            emptyInput.type = 'file';
            // Сбросим свойство value и files
            this.$refs.hiddenInput.value = '';
            this.files = emptyInput.files;
            this.filesText = this.placeholder || 'Прикрепить файл';
        }
    },
};
</script>
<style scoped lang="scss">
.file-input {
    max-width: 100%;

    &__hidden {
        position: absolute;
        margin-left: -1px;
        width: 1px;
        height: 1px;
        clip-path: inset(2px);
    }

    &__visible {
        display: flex;
        gap: 4px;
        align-items: flex-start;
        color: var(--accent, blue);
    }

    &__icon-n-text {
        display: flex;
        min-width: 206px;
        gap: 4px;
        align-items: flex-start;
        cursor: pointer;
    }

    &__icon {
        margin-top: 2px;
        flex-shrink: 0;
        width: 20px;
        height: 20px;
    }

    &__text {
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        font-weight: 500;
    }

    &__delete-btn {
        display: none;
        cursor: pointer;

        &,
        &>svg {
            width: 20px;
            height: 20px;
            color: var(--dark-gray, #575F6E);
        }
    }

    &.has-attachment {
        .file-input__delete-btn {
            display: block;
        }
    }

}</style>